import { useState, useEffect, useContext, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import Axios from 'axios';
import { ActionButton, DataStatus, ExportButton } from 'components';
import { AnalisaBarangJadiRABApi, RencanaAnggaranBiayaApi } from 'api';
import { TablePrelim } from '../Section';
import { RABContext } from '../RABContext';
import { RupiahConvert } from 'utilities';
import FileSaver from 'file-saver';
import { IoClose } from 'react-icons/io5';

const ModalPrelim = ({ id, show, onHide, onSubmit }) => {
  const { dataPrelim: prelimContext, type: TYPE } = useContext(RABContext);
  const [dataKelompokPrelim, setDataKelompokPrelim] = useState([]);
  const [dataPrelim, setDataPrelim] = useState([]);
  const [fetchingStatus, setFetchingStatus] = useState({
    loading: true,
    success: false,
  });

  const getInitialData = async () => {
    setFetchingStatus({
      loading: true,
      success: false,
    });

    return await Axios.all([AnalisaBarangJadiRABApi.getKelompokPrelim()])
      .then(
        Axios.spread((kelompokPrelim) => {
          const rawKelompokPrelim = kelompokPrelim?.data?.data;

          setDataKelompokPrelim(rawKelompokPrelim ?? []);
          setDataPrelim(prelimContext);
          setFetchingStatus({
            loading: false,
            success: true,
          });
        })
      )
      .catch(() => {
        setFetchingStatus({
          loading: false,
          success: false,
        });
      });
  };

  const getGrandTotal = useMemo(
    () =>
      dataPrelim.reduce((prev, current) => {
        const newQtyItem = current.qty_item ? parseFloat(current.qty_item) : 0;
        const newHarga = current.harga ? parseFloat(current.harga) : 0;
        const newQtyDurasi = current.qty_durasi
          ? parseFloat(current.qty_durasi)
          : 0;
        const newKonts = current.konstanta ? parseFloat(current.konstanta) : 0;
        const subTotal = newQtyItem * newHarga;
        const total = subTotal;

        return prev + total;
      }, 0),
    [dataPrelim]
  );

  useEffect(() => {
    getInitialData();
  }, [show]);

  return (
    <Modal size="xl" show={show} onHide={onHide}>
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <b className="text-primary">Analisa Prelim</b>

        <div style={{ float: 'right' }}>
          {TYPE === 'DETAIL' && (
            <ExportButton
              noMargin
              size="sm"
              onClick={() => {
                RencanaAnggaranBiayaApi.exportPrelim({
                  id_rab: id,
                  tipe: 'excel',
                })
                  .then(({ data }) => {
                    FileSaver.saveAs(data.data);
                  })
                  .catch((res) => alert(res));
              }}
            />
          )}
          <IoClose onClick={onHide} size={24} style={{ cursor: 'pointer' }} />
        </div>
      </Modal.Header>
      <Modal.Body>
        {fetchingStatus.loading ? (
          <DataStatus loading text="Memuat data . . ." />
        ) : fetchingStatus.success ? (
          <>
            {dataKelompokPrelim.map((val, index) => (
              <TablePrelim
                key={index}
                dataKelompokPrelim={val}
                dataPrelim={dataPrelim}
                setDataPrelim={setDataPrelim}
              />
            ))}

            {/* Grand Total Section */}
            <div className="text-right p-2 border" style={{ fontSize: 14 }}>
              <b>Grand Total : </b>
              <b className="ml-3">
                {RupiahConvert(String(parseInt(getGrandTotal))).detail}
              </b>
            </div>
            <hr />

            {/* Button Section */}
            {TYPE !== 'DETAIL' && (
              <div className="text-right">
                <ActionButton
                  className="px-4"
                  text="Simpan Prelim"
                  onClick={() => onSubmit(dataPrelim)}
                />
              </div>
            )}
          </>
        ) : (
          <DataStatus text="Data gagal dimuat!" />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPrelim;
